import {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Me from './assets/me.JPG';
import Fam from './assets/fam.jpeg';
import Music from './assets/music.jpg';
import Tubeamp from './assets/tubeamp.jpg';
import AltoidsPreamp from './assets/altoids_preamp.jpg';

function About(props) {
  const [famUnderline, setFamUnderline] = useState(false);
  const [musicUnderline, setMusicUnderline] = useState(false);
  const [engineeringUnderline, setEngineeringUnderline] = useState(false);



    return (
        <div style={{
          backgroundColor: props.mode === 'light' ? '#f1eee6' : '#28282b',
          transition: '.5s'
        }}>
          
      <div className='bodyContainer' style={{
        // display: 'flex',
        // flexDirection: 'row'
      }}>
<div style={{
  marginTop: '5%',
  width: '100%',
  // border: '1px solid #28282b',
  display: 'flex',
  flexDireciton: 'row',
  justifyContent: 'space-around',
  alignItems: 'center'

}}>
      <img src={Me} style={{
        width: '32%',
        order: '1'
      }}></img>
      <img src={Fam} style={{
        width: '20%',
        order: '2', 
        alignSelf: 'flex-start'
      }}
      onMouseEnter={() => setFamUnderline(true)}
      onMouseLeave={() => setFamUnderline(false)}>
      </img>
      <img src={Music} style={{
        width: '25%',
        order: '3',
        alignSelf: 'flex-end'
      }}
      onMouseEnter={() => setMusicUnderline(true)}
      onMouseLeave={() => setMusicUnderline(false)}
      >
      </img>
      <div style={{
        width: '19%',
        order: '4',
        display: 'flex',
        flexDirection: 'column',
        
      }}
      onMouseEnter={() => setEngineeringUnderline(true)}
      onMouseLeave={() => setEngineeringUnderline(false)}>
      <img src={AltoidsPreamp} style={{
        width: '100%',
        // justifySelf: 'flex-start'
      }}
      >
      </img>

<img src={Tubeamp} style={{
        width: '100%',
        // justifySelf: 'flex-end'
      }}></img>

</div>
</div>

        <p style={{
    fontSize: '20px', 
    fontWeight: '100', 
    marginLeft: '5%', 
    letterSpacing: '5px',
    color: props.mode === 'dark' ? '#f1eee6' : '#28282b',
    transition: '.5s',
    textIndent: '20px'
    }}>
          I am a web developer, 
          <span style={{
            textDecoration: musicUnderline === true ? 'underline' : 'none'
          }}> musician</span>
          , and engineer living in Houston, Texas. 

          <span style={{
            textDecoration: famUnderline === true ?'underline' : 'none'
          }}>I am married to my high school sweetheart, and we are expecting our fourth (!!) little girl this summer.</span> 
        </p>

        <p style={{
    fontSize: '20px', 
    fontWeight: '100', 
    marginLeft: '5%', 
    letterSpacing: '5px',
    color: props.mode === 'dark' ? '#f1eee6' : '#28282b',
    transition: '.5s',
    textIndent: '40px'
    }}>
          <span style={{
            textDecoration: musicUnderline === true ? 'underline' : 'none'
          }}>My first love was music.</span>
           I grew up playing piano from a very young age, and eventually started playing guitar and trumpet. This led me to serving on worship teams (which is where I met my wife), playing in bands, engineering audio sessions, and attending the University of Houston Moores School of Music.  
        </p>

        <p style={{
    fontSize: '20px', 
    fontWeight: '100', 
    marginLeft: '5%', 
    letterSpacing: '5px',
    color: props.mode === 'dark' ? '#f1eee6' : '#28282b',
    transition: '.5s',
    textIndent: '40px'
    }}>
           My interest in coding started when I needed a website for my indie record label. After I made that, I ended up designing websites for friends that are artists/musicians. Eventually I wanted to learn more, so I enrolled in a six month full stack course through The University of Texas in Austin, where I have learned html, css, vanilla javascript, react, sql, and node.js. 
        </p>

        <p style={{
    fontSize: '20px', 
    fontWeight: '100', 
    marginLeft: '5%', 
    letterSpacing: '5px',
    color: props.mode === 'dark' ? '#f1eee6' : '#28282b',
    transition: '.5s',
    textIndent: '40px'
    }}>
           When I'm not writing code, I enjoy <span style={{
            textDecoration: famUnderline === true ? 'underline' : 'none'
           }}>spending time with my family</span>, <span style={{
            textDecoration: musicUnderline === true ? 'underline' : 'none'
           }}>writing and recording music,</span> and <span style={{
            textDecoration: engineeringUnderline === true ? 'underline' : 'none'
           }}>designing and building audio devices.</span> 
        </p>
      
      </div>
      </div>
      );
}

export default About